import { StandardEvents } from '@shopify/events';

class ReFuelOffer extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.addEventListener('change', () => this.refresh(), {signal});
    this.closest('.shopify-section')?.addEventListener('input', () => this.refresh(), {signal});
    document.addEventListener(StandardEvents.cartLinesUpdate, event => {
      if (event.promise) event.promise.then(() => this.refresh()).catch(() => {});
      else this.refresh();
    }, {signal});
    this.refresh();
  }
  disconnectedCallback() { this.controller?.abort(); }
  async refresh() {
    const generation = this.generation = (this.generation || 0) + 1;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js', {credentials:'same-origin', signal:this.controller.signal});
      if (!response.ok) return;
      const cart = await response.json();
      if (generation !== this.generation) return;
      const text = this.querySelector('[data-refuel-price]');
      text.textContent = 'Én adapter for 99 kr sammen med Apex';
      this.querySelector('[data-refuel-existing]').hidden = !cart.items.some(item => String(item.product_id) === '15405097419026');
    } catch (error) { if (error.name !== 'AbortError') this.querySelector('[data-refuel-price]').textContent = 'Tilbudet beregnes i handlekurven.'; }
  }
}
if (!customElements.get('refuel-offer')) customElements.define('refuel-offer', ReFuelOffer);